(function () {
  'use strict';

  var DESKTOP_MQ = window.matchMedia('(min-width: 768px)');
  var pendingTracks = [];

  var STL_PAD = 8;
  var STL_CARD_PIN_GAP = 10;
  var STL_CARD_PIN_GAP_ABOVE = 6;
  var STL_CARD_W_DEFAULT = 140;
  var STL_CARD_H_DEFAULT = 210;
  var STL_CARD_W_LARGE = 160;
  var STL_CARD_H_LARGE = 230;

  function debounce(fn, ms) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, ms);
    };
  }

  function clamp(v, minV, maxV) {
    return Math.max(minV, Math.min(maxV, v));
  }

  function getWrapper(track) {
    return track.closest('.lop-shop-the-look-carousel__wrapper');
  }

  function getStage(track) {
    return track.closest('.lop-shop-the-look-carousel__stage');
  }

  function syncVisibleWidth(track) {
    var wrapper = getWrapper(track);
    if (!wrapper) return;
    var width = wrapper.getBoundingClientRect().width;
    if (width > 0) {
      track.style.setProperty('--carousel-visible-width', width + 'px');
    }
  }

  function updateHotspotCardPosition(hotspot) {
    var figure = hotspot && hotspot.closest('.lop-shop-the-look-carousel__figure');
    if (!figure) return;
    var cardEl = hotspot.querySelector('.lop-hotspot__card');
    var cardW = cardEl ? cardEl.offsetWidth : (window.innerWidth >= 1440 ? STL_CARD_W_LARGE : STL_CARD_W_DEFAULT);
    var cardH = cardEl ? cardEl.offsetHeight : (window.innerWidth >= 1440 ? STL_CARD_H_LARGE : STL_CARD_H_DEFAULT);
    if (cardEl) {
      var cardRect = cardEl.getBoundingClientRect();
      if (cardRect.width > 0) cardW = cardRect.width;
      if (cardRect.height > 0) cardH = cardRect.height;
    }
    var fr = figure.getBoundingClientRect();
    var fLeft = fr.left + STL_PAD;
    var fTop = fr.top + STL_PAD;
    var fRight = fr.right - STL_PAD;
    var fBottom = fr.bottom - STL_PAD;
    var hr = hotspot.getBoundingClientRect();
    var pinCenterX = hr.left + hr.width / 2;
    var pinCenterY = hr.top + hr.height / 2;
    var pinBottom = hr.bottom;
    var pinTop = hr.top;
    var pinLeft = hr.left;
    var pinRight = hr.right;
    var fitsBelow = Math.max(fTop, pinBottom + STL_CARD_PIN_GAP) <= fBottom - cardH;
    var fitsAbove = fTop <= Math.min(fBottom - cardH, pinTop - STL_CARD_PIN_GAP_ABOVE - cardH);
    var fitsLeft = fLeft <= Math.min(fRight - cardW, pinLeft - STL_CARD_PIN_GAP - cardW);
    var fitsRight = Math.max(fLeft, pinRight + STL_CARD_PIN_GAP) <= fRight - cardW;
    var placement = 'below';
    var cardLeft = pinCenterX - cardW / 2;
    var cardTop = pinBottom + STL_CARD_PIN_GAP;
    if (fitsBelow) {
      placement = 'below';
      cardLeft = pinCenterX - cardW / 2;
      cardTop = pinBottom + STL_CARD_PIN_GAP;
    } else if (fitsAbove) {
      placement = 'above';
      cardLeft = pinCenterX - cardW / 2;
      cardTop = pinTop - STL_CARD_PIN_GAP_ABOVE - cardH;
    } else if (fitsLeft) {
      placement = 'left';
      cardLeft = pinLeft - STL_CARD_PIN_GAP - cardW;
      cardTop = pinCenterY - cardH / 2;
    } else if (fitsRight) {
      placement = 'right';
      cardLeft = pinRight + STL_CARD_PIN_GAP;
      cardTop = pinCenterY - cardH / 2;
    } else {
      var spaces = {
        below: fBottom - pinBottom - STL_CARD_PIN_GAP,
        above: pinTop - fTop - STL_CARD_PIN_GAP_ABOVE,
        left: pinLeft - fLeft - STL_CARD_PIN_GAP,
        right: fRight - pinRight - STL_CARD_PIN_GAP
      };
      placement = 'below';
      var bestSpace = spaces.below;
      if (spaces.above > bestSpace) {
        placement = 'above';
        bestSpace = spaces.above;
      }
      if (spaces.left > bestSpace) {
        placement = 'left';
        bestSpace = spaces.left;
      }
      if (spaces.right > bestSpace) {
        placement = 'right';
      }
      if (placement === 'above') {
        cardLeft = pinCenterX - cardW / 2;
        cardTop = pinTop - STL_CARD_PIN_GAP_ABOVE - cardH;
      } else if (placement === 'left') {
        cardLeft = pinLeft - STL_CARD_PIN_GAP - cardW;
        cardTop = pinCenterY - cardH / 2;
      } else if (placement === 'right') {
        cardLeft = pinRight + STL_CARD_PIN_GAP;
        cardTop = pinCenterY - cardH / 2;
      } else {
        cardLeft = pinCenterX - cardW / 2;
        cardTop = pinBottom + STL_CARD_PIN_GAP;
      }
    }
    if (placement === 'above') {
      cardTop = clamp(
        pinTop - STL_CARD_PIN_GAP_ABOVE - cardH,
        fTop,
        Math.min(fBottom - cardH, pinTop - STL_CARD_PIN_GAP_ABOVE - cardH)
      );
      cardLeft = clamp(pinCenterX - cardW / 2, fLeft, fRight - cardW);
    } else if (placement === 'below') {
      cardLeft = clamp(pinCenterX - cardW / 2, fLeft, fRight - cardW);
      cardTop = clamp(
        pinBottom + STL_CARD_PIN_GAP,
        Math.max(fTop, pinBottom + STL_CARD_PIN_GAP),
        fBottom - cardH
      );
    } else if (placement === 'left') {
      cardLeft = clamp(
        pinLeft - STL_CARD_PIN_GAP - cardW,
        fLeft,
        Math.min(fRight - cardW, pinLeft - STL_CARD_PIN_GAP - cardW)
      );
      cardTop = clamp(pinCenterY - cardH / 2, fTop, fBottom - cardH);
    } else {
      cardLeft = clamp(
        pinRight + STL_CARD_PIN_GAP,
        Math.max(fLeft, pinRight + STL_CARD_PIN_GAP),
        fRight - cardW
      );
      cardTop = clamp(pinCenterY - cardH / 2, fTop, fBottom - cardH);
    }
    var tx = 0;
    var ty = 0;
    if (placement === 'below') {
      tx = cardLeft - (pinCenterX - cardW / 2);
      ty = cardTop - (pinBottom + STL_CARD_PIN_GAP);
    } else if (placement === 'above') {
      tx = cardLeft - (pinCenterX - cardW / 2);
      ty = cardTop - (pinTop - STL_CARD_PIN_GAP_ABOVE - cardH);
    } else if (placement === 'left') {
      tx = cardLeft - (pinLeft - STL_CARD_PIN_GAP - cardW);
      ty = cardTop - (pinCenterY - cardH / 2);
    } else {
      tx = cardLeft - (pinRight + STL_CARD_PIN_GAP);
      ty = cardTop - (pinCenterY - cardH / 2);
    }
    var lopCardOffsetPx = placement === 'above' ? STL_CARD_PIN_GAP_ABOVE : STL_CARD_PIN_GAP;
    hotspot.setAttribute('data-card-placement', placement);
    hotspot.style.setProperty('--card-translate-x', tx + 'px');
    hotspot.style.setProperty('--card-translate-y', ty + 'px');
    hotspot.style.setProperty('--lop-card-offset', lopCardOffsetPx + 'px');
    if (cardEl) {
      var offsetVal = lopCardOffsetPx + 'px';
      if (placement === 'below') {
        cardEl.style.top = 'calc(100% + ' + offsetVal + ')';
        cardEl.style.bottom = cardEl.style.left = cardEl.style.right = '';
      } else if (placement === 'above') {
        cardEl.style.bottom = 'calc(100% + ' + offsetVal + ')';
        cardEl.style.top = cardEl.style.left = cardEl.style.right = '';
      } else if (placement === 'left') {
        cardEl.style.right = 'calc(100% + ' + offsetVal + ')';
        cardEl.style.left = cardEl.style.top = cardEl.style.bottom = '';
      } else {
        cardEl.style.left = 'calc(100% + ' + offsetVal + ')';
        cardEl.style.right = cardEl.style.top = cardEl.style.bottom = '';
      }
    }
  }

  function updateAllHotspotPositions(track) {
    if (!track) return;
    track.querySelectorAll('.lop-shop-the-look-carousel__figure .lop-hotspot').forEach(function (h) {
      if (DESKTOP_MQ.matches || h.classList.contains('is-open')) {
        updateHotspotCardPosition(h);
      }
    });
  }

  function closeCarouselHotspots(track) {
    if (!track) return;
    track.querySelectorAll('.lop-shop-the-look-carousel__figure .lop-hotspot.is-open').forEach(function (h) {
      h.classList.remove('is-open');
    });
  }

  function scheduleHotspotCardPosition(hotspot) {
    updateHotspotCardPosition(hotspot);
    requestAnimationFrame(function () {
      updateHotspotCardPosition(hotspot);
      requestAnimationFrame(function () {
        updateHotspotCardPosition(hotspot);
      });
    });
  }

  function bindHotspotHover(wrapper, track) {
    if (!wrapper || track._lopHotspotMouseOver) return;
    track._lopHotspotMouseOver = function (e) {
      if (!DESKTOP_MQ.matches) return;
      var hotspot = e.target.closest && e.target.closest('.lop-hotspot');
      if (!hotspot || !hotspot.closest('.lop-shop-the-look-carousel__figure')) return;
      if (!track.contains(hotspot)) return;
      var rel = e.relatedTarget;
      if (rel && hotspot.contains(rel)) return;
      updateHotspotCardPosition(hotspot);
    };
    wrapper.addEventListener('mouseover', track._lopHotspotMouseOver);
  }

  function activateCarouselHotspot(track, hotspot) {
    if (!track || !hotspot) return;

    var willOpen = !hotspot.classList.contains('is-open');
    track.querySelectorAll('.lop-shop-the-look-carousel__figure .lop-hotspot.is-open').forEach(function (h) {
      if (h !== hotspot) h.classList.remove('is-open');
    });
    hotspot.classList.toggle('is-open', willOpen);

    if (willOpen) {
      scheduleHotspotCardPosition(hotspot);
    }
  }

  function handleCarouselHotspotTap(track, e) {
    if (DESKTOP_MQ.matches) return false;
    var target = e.target;
    var hotspot = target.closest && target.closest('.lop-hotspot');
    if (!hotspot || !hotspot.closest('.lop-shop-the-look-carousel__figure')) return false;
    if (!track.contains(hotspot)) return false;
    if (target.closest && target.closest('.lop-hotspot__card')) return false;

    var now = Date.now();
    if (
      track._lopLastHotspotTapAt &&
      track._lopLastHotspotTapTarget === hotspot &&
      now - track._lopLastHotspotTapAt < 400
    ) {
      return true;
    }
    track._lopLastHotspotTapAt = now;
    track._lopLastHotspotTapTarget = hotspot;

    if (e.cancelable) e.preventDefault();
    e.stopPropagation();

    activateCarouselHotspot(track, hotspot);
    return true;
  }

  function bindHotspotTap(wrapper, track, flkty) {
    if (!wrapper || track._lopHotspotClick) return;

    track._lopHotspotClick = function (e) {
      handleCarouselHotspotTap(track, e);
    };
    wrapper.addEventListener('click', track._lopHotspotClick, true);

    track._lopHotspotTouchEnd = function (e) {
      if (handleCarouselHotspotTap(track, e)) {
        track._lopHotspotSuppressClick = Date.now();
      }
    };
    wrapper.addEventListener('touchend', track._lopHotspotTouchEnd, { capture: true, passive: false });

    track._lopHotspotClickGuard = function (e) {
      if (!track._lopHotspotSuppressClick) return;
      if (Date.now() - track._lopHotspotSuppressClick > 500) {
        track._lopHotspotSuppressClick = 0;
        return;
      }
      var hotspot = e.target.closest && e.target.closest('.lop-hotspot');
      if (!hotspot || !hotspot.closest('.lop-shop-the-look-carousel__figure')) return;
      e.preventDefault();
      e.stopPropagation();
      track._lopHotspotSuppressClick = 0;
    };
    wrapper.addEventListener('click', track._lopHotspotClickGuard, true);

    if (flkty) {
      flkty.on('staticClick', function (event) {
        handleCarouselHotspotTap(track, event);
      });
    }

    track._lopHotspotDocClick = function (e) {
      if (DESKTOP_MQ.matches) return;
      if (!track.querySelector('.lop-hotspot.is-open')) return;
      if (e.target.closest && e.target.closest('.lop-shop-the-look-carousel .lop-hotspot')) return;
      closeCarouselHotspots(track);
    };
    document.addEventListener('click', track._lopHotspotDocClick, true);
  }

  function markLastVisibleSlide(track, flkty) {
    track.querySelectorAll('.carousel__slide.is-last-visible').forEach(function (slide) {
      slide.classList.remove('is-last-visible');
    });
    if (!DESKTOP_MQ.matches || !flkty || !flkty.selectedSlide || !flkty.selectedSlide.cells) return;
    var cells = flkty.selectedSlide.cells;
    if (!cells.length) return;
    var lastCell = cells[cells.length - 1];
    if (lastCell && lastCell.element) {
      lastCell.element.classList.add('is-last-visible');
    }
  }

  function updateNav(flkty, nav, btnPrev, btnNext, totalCells) {
    var needsNav = DESKTOP_MQ.matches ? totalCells >= 4 : totalCells > 1;
    if (nav) {
      nav.hidden = !needsNav;
      nav.setAttribute('aria-hidden', needsNav ? 'false' : 'true');
    }
    if (!flkty || !needsNav) return;
    if (btnPrev) btnPrev.disabled = flkty.selectedIndex <= 0;
    if (btnNext) btnNext.disabled = flkty.selectedIndex >= flkty.slides.length - 1;
  }

  function buildDots(dotsContainer, flkty) {
    if (!dotsContainer || !flkty) return;
    dotsContainer.innerHTML = '';
    var pageCount = flkty.slides.length;
    if (pageCount <= 1) {
      dotsContainer.hidden = true;
      return;
    }
    dotsContainer.hidden = false;
    for (var i = 0; i < pageCount; i++) {
      (function (index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'dot';
        dot.setAttribute('aria-label', 'Ir al slide ' + (index + 1));
        dot.addEventListener('click', function () {
          flkty.select(index);
        });
        dotsContainer.appendChild(dot);
      })(i);
    }
  }

  function syncDots(dotsContainer, flkty) {
    if (!dotsContainer || !flkty) return;
    var dots = dotsContainer.querySelectorAll('.dot');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-selected', i === flkty.selectedIndex);
    }
  }

  function showReady(track) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        track.classList.add('lop-carousel-ready');
      });
    });
  }

  function cleanupCarousel(track) {
    var wrapper = getWrapper(track);
    if (wrapper && track._lopHotspotMouseOver) {
      wrapper.removeEventListener('mouseover', track._lopHotspotMouseOver);
      track._lopHotspotMouseOver = null;
    }
    if (wrapper && track._lopHotspotClick) {
      wrapper.removeEventListener('click', track._lopHotspotClick, true);
      track._lopHotspotClick = null;
    }
    if (wrapper && track._lopHotspotTouchEnd) {
      wrapper.removeEventListener('touchend', track._lopHotspotTouchEnd, { capture: true });
      track._lopHotspotTouchEnd = null;
    }
    if (wrapper && track._lopHotspotClickGuard) {
      wrapper.removeEventListener('click', track._lopHotspotClickGuard, true);
      track._lopHotspotClickGuard = null;
    }
    track._lopHotspotSuppressClick = 0;
    track._lopLastHotspotTapAt = 0;
    track._lopLastHotspotTapTarget = null;
    if (track._lopHotspotDocClick) {
      document.removeEventListener('click', track._lopHotspotDocClick, true);
      track._lopHotspotDocClick = null;
    }
    if (track._lopResizeHandler) {
      window.removeEventListener('resize', track._lopResizeHandler);
      track._lopResizeHandler = null;
    }
    if (track._lopFlkty) {
      track._lopFlkty.destroy();
      track._lopFlkty = null;
    }
    track.classList.remove('lop-carousel-ready');
    delete track.dataset.lopCarouselInit;
  }

  function bindLayoutHandlers(track, flkty, nav, btnPrev, btnNext, dotsContainer, wrapper, totalCells) {
    function syncUI() {
      syncVisibleWidth(track);
      markLastVisibleSlide(track, flkty);
      updateNav(flkty, nav, btnPrev, btnNext, totalCells);
      syncDots(dotsContainer, flkty);
      updateAllHotspotPositions(track);
    }

    function resizeCarousel() {
      syncVisibleWidth(track);
      if (flkty && flkty.resize) flkty.resize();
      updateAllHotspotPositions(track);
      buildDots(dotsContainer, flkty);
      markLastVisibleSlide(track, flkty);
      updateNav(flkty, nav, btnPrev, btnNext, totalCells);
      syncDots(dotsContainer, flkty);
    }

    flkty.on('select', function () {
      if (!DESKTOP_MQ.matches) closeCarouselHotspots(track);
      syncUI();
    });
    flkty.on('settle', syncUI);
    flkty.on('ready', function () {
      syncUI();
      showReady(track);
    });

    track.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function onLoad() {
        img.removeEventListener('load', onLoad);
        resizeCarousel();
        syncUI();
      });
    });

    var debouncedResize = debounce(resizeCarousel, 150);
    window.addEventListener('resize', debouncedResize, { passive: true });
    track._lopResizeHandler = debouncedResize;

    bindHotspotHover(wrapper, track);
    bindHotspotTap(wrapper, track, flkty);

    syncUI();
    showReady(track);
  }

  function initLopShopTheLookCarousel(track) {
    if (!track) return;

    if (typeof Flickity === 'undefined') {
      if (pendingTracks.indexOf(track) === -1) pendingTracks.push(track);
      return;
    }

    cleanupCarousel(track);

    var slides = track.querySelectorAll('.carousel__slide');
    if (!slides.length) {
      track.classList.add('lop-carousel-ready');
      return;
    }

    var wrapper = getWrapper(track);
    var stage = getStage(track);
    var nav = stage ? stage.querySelector('.lop-shop-the-look-carousel__nav') : null;
    var btnPrev = nav ? nav.querySelector('.lop-shop-the-look-carousel__nav-btn--prev') : null;
    var btnNext = nav ? nav.querySelector('.lop-shop-the-look-carousel__nav-btn--next') : null;
    var dotsContainer = wrapper ? wrapper.querySelector('.lop-shop-the-look-carousel__dots') : null;

    syncVisibleWidth(track);
    track.setAttribute('data-slide-count', String(slides.length));
    track.classList.toggle('lop-carousel--few-slides', slides.length < 3);

    var flkty = new Flickity(track, {
      cellAlign: 'left',
      contain: true,
      groupCells: slides.length >= 3 ? true : 1,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: false,
      cellSelector: '.carousel__slide',
      adaptiveHeight: false
    });

    track._lopFlkty = flkty;
    track.dataset.lopCarouselInit = 'true';

    buildDots(dotsContainer, flkty);

    if (nav && nav.dataset.lopNavBound !== 'true') {
      nav.dataset.lopNavBound = 'true';
      nav.addEventListener('click', function (e) {
        var activeFlkty = track._lopFlkty;
        if (!activeFlkty) return;
        if (e.target.closest('.lop-shop-the-look-carousel__nav-btn--prev')) {
          activeFlkty.previous();
        } else if (e.target.closest('.lop-shop-the-look-carousel__nav-btn--next')) {
          activeFlkty.next();
        }
      });
    }

    bindLayoutHandlers(track, flkty, nav, btnPrev, btnNext, dotsContainer, wrapper, slides.length);
  }

  function flushPendingTracks() {
    if (typeof Flickity === 'undefined') return;
    while (pendingTracks.length) {
      initLopShopTheLookCarousel(pendingTracks.shift());
    }
  }

  window.initLopShopTheLookCarousel = initLopShopTheLookCarousel;

  if (typeof Flickity !== 'undefined') {
    flushPendingTracks();
  } else {
    var flickityPoll = setInterval(function () {
      if (typeof Flickity === 'undefined') return;
      clearInterval(flickityPoll);
      flushPendingTracks();
    }, 50);
    setTimeout(function () {
      clearInterval(flickityPoll);
    }, 10000);
  }
})();
